import { render, staticRenderFns } from "./EnumAttributeDialog.vue?vue&type=template&id=f79e449c&scoped=true&"
import script from "./EnumAttributeDialog.vue?vue&type=script&lang=js&"
export * from "./EnumAttributeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79e449c",
  null
  
)

export default component.exports